module.exports = __webpack_public_path__ + "static/media/empty-coach@3x.33b932c9.png";